const BASE_URL = ' http://10.164.15.70:2222/rest/'
export default {
    BASE_URL
}
